import React from 'react'
import { Link } from 'react-router-dom'

export default function Mandarin() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd9 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Mandarin </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Mandarin </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Mandarin</h2>
 
      </div>

      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>types:</h5>
        <h5 className=' mt-3'>Spanish Murcott
        </h5>
        <h5 className=' mt-3'>  kini Murcott
        </h5>
        <h5 className=' mt-3'>    Celemntine </h5>
        <h5 className=' mt-3'>   Fremont</h5>
      </div>
      <hr />
      <hr />
          <h2 className='text-primary my-3'>Season:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>from December to May
          </h5>
        </li>


      </ul>
      <hr />

      <h2 className='text-primary my-3'>Packing</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>
          Net weight: 7.5 kg, gross weight: 8 kg – open top carton
          NW : 9.5 kgs carton or plastic 
          </h5>
        </li>

      </ul>
     <hr />

      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
